import { getUrlSearchParams } from './getUrlSearchParams';
import { localStorageItemName } from './localStorageItemName';

const urlParams = getUrlSearchParams();
const hashFromUrl = urlParams.get('hash');

export const hash = () => hashFromUrl || localStorage.getItem(localStorageItemName);
